/* eslint-disable no-shadow */
/* eslint-disable no-console */
import './SpacerBlockMedium.css';
import type { BlockComponentProps } from 'client-react-block-renderer';
import React from 'react';

interface Props extends BlockComponentProps<BlockData, BlockConfig> {}

interface BlockConfig {}

interface BlockData {}

const SpacerBlockMedium = (props: Props) => {
  return <div className="rcm-spacer-medium"></div>;
};
export default SpacerBlockMedium;
